import { z } from "zod";

const DeleteBookingExtraResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
});

export { DeleteBookingExtraResponseSchema };
export type DeleteBookingExtraResponse = z.infer<typeof DeleteBookingExtraResponseSchema>;
